import { Component, Input, EventEmitter, Output } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'default-research-infografic',
  templateUrl: 'default-research-infografic.component.html',
  styleUrls: ['default-research-infografic.component.scss'],
})
export class DefaultResearchInfograficComponent {

  @Output() advancedSearchOpen: EventEmitter<any> = new EventEmitter();

  onAdvSearchOpenClick() {
    this.advancedSearchOpen.emit();
  }
}
